import type { WorkflowHistoryItem, WorkflowRequest } from "./workflowTypes";

function nowIso() {
  return new Date().toISOString();
}

function pushHistory(w: WorkflowRequest, item: WorkflowHistoryItem): WorkflowRequest {
  return {
    ...w,
    updated_at: item.at,
    version: (w.version || 0) + 1,
    history: [...(w.history || []), item],
  };
}

export function submitRequest(w: WorkflowRequest, by: string): WorkflowRequest {
  if (!w) return w;
  const at = nowIso();
  const next: WorkflowRequest = {
    ...w,
    status: "submitted",
    submitted_by: String(by || ""),
  };
  return pushHistory(next, { action: "submit", by: String(by || ""), at });
}

export function approveRequest(w: WorkflowRequest, by: string): WorkflowRequest {
  if (!w) return w;
  const at = nowIso();
  const next: WorkflowRequest = { ...w, status: "approved" };
  return pushHistory(next, { action: "approve", by: String(by || ""), at });
}

export function rejectRequest(w: WorkflowRequest, by: string, reason?: string): WorkflowRequest {
  if (!w) return w;
  const at = nowIso();
  const next: WorkflowRequest = { ...w, status: "rejected" };
  return pushHistory(next, { action: "reject", by: String(by || ""), at, note: reason || "" });
}

export function cancelRequest(w: WorkflowRequest, by: string): WorkflowRequest {
  if (!w) return w;
  const at = nowIso();
  const next: WorkflowRequest = { ...w, status: "cancelled" };
  return pushHistory(next, { action: "cancel", by: String(by || ""), at });
}
